import api from "./axiosConfig";
import endpoints from "./endpoints";
import axios from "axios";

const apiService = {
  getCity: async () => {
    try {
      const response = await api.get(endpoints.GET_CITY);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getLanguages: async () => {
    try {
      const response = await api.get(endpoints.GET_LANGUAGES);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getHours: async () => {
    try {
      const response = await api.get(endpoints.GET_HOURS);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getPickPoints: async (body) => {
    try {
      const response = await api.post(endpoints.GET_PICK_POINTS, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getCategories: async (body) => {
    try {
      const response = await api.post(endpoints.GET_CATEGORIES, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getPreTrips: async (body) => {
    try {
      const response = await api.post(endpoints.GET_PRE_TRIPS, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getPlanTrips: async (body) => {
    try {
      const response = await api.post(endpoints.GET_PLAN_TRIPS, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getStaticContent: async () => {
    try {
      const response = await api.get(endpoints.GET_STATIC_CONTENT);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getMobileOtp: async (body) => {
    try {
      const response = await api.post(endpoints.GET_MOBILE_OTP, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getResendOtp: async (body) => {
    try {
      const response = await api.post(endpoints.GET_RESEND_OTP, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  createOrder: async (body) => {
    try {
      const response = await api.post(endpoints.CREATE_ORDER, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getGeneratedTrip: async (body) => {
    try {
      const response = await api.post(endpoints.GET_GENERATED_TRIP, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getBlogs: async () => {
    try {
      // Use direct axios call for blogs endpoint since it's a full URL
      const response = await axios.get(endpoints.GET_BLOGS, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Blogs API Error:", error);
      throw error;
    }
  },
  getBlogDetail: async (blogName) => {
    try {
      // Use direct axios call for blog detail endpoint with POST method
      const response = await axios.post(endpoints.GET_BLOG_DETAIL, {
        blogName: blogName
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Blog Detail API Error:", error);
      throw error;
    }
  },
};

export default apiService;
